/** Plan modus rail: top-level incomplete non-backlog tasks of the filtered project. */
export function buildPlanRailTasks(planMode, filteredTasks) {
  if (!planMode) return [];
  return (filteredTasks || [])
    .filter(
      (task) =>
        !task.parentId && task.status !== 'Backlog' && !task.completed,
    )
    .sort(comparePlanRailTasks);
}

function comparePlanRailTasks(a, b) {
  if (!a.date && !b.date) {
    return (a.orderKey || '') < (b.orderKey || '') ? -1 : 1;
  }
  if (!a.date) return 1;
  if (!b.date) return -1;
  if (a.date !== b.date) return a.date < b.date ? -1 : 1;
  return (a.orderKey || '') < (b.orderKey || '') ? -1 : 1;
}
